// Polyfill since IE11 doesn't support `URLSearchParams`
import * as Cookies from "js-cookie";

const URLSearchParams = window.URLSearchParams || require('url-search-params');
const searchParams = new URLSearchParams(window.location.search);
export const devModeEnabled = searchParams.has('dev') || Cookies.get('dev') != undefined;
